<template>
    <h1>Usuário Sem Permissão para acessar a rotina.</h1>
</template>

<script>
    export default {
        name: "401"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/Error401.vue